import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Tray} from '@models/tray.model';
import {Slot} from '@models/slot.model';
import {TrayType} from "@models/enums/tray-type.enum";

@Component({
    selector: 'app-tray',
    templateUrl: './tray.component.html',
    styleUrls: ['./tray.component.scss']
})
export class TrayComponent implements OnInit {

    @Input() tray: Tray;

    @Output() edit = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() toggleVisibility = new EventEmitter<any>();
    @Output() selectSlot = new EventEmitter<any>();

    @HostBinding('class.disabled') isDisabled() {
        return this.tray && this.tray.disabled === true;
    }

    constructor() {
    }

    ngOnInit() {
    }

    editTrayClick() {
        this.edit.emit(this.tray);
    }

    deleteTrayClick() {
        this.delete.emit(this.tray);
    }

    toggleTrayStateClick() {
        if (this.canVisibilityBeChanged()) {
            this.toggleVisibility.emit(this.tray);
        }
    }

    onSlotClick(slot: Slot) {
        this.selectSlot.emit(slot);
    }

    getName(tray: Tray) {
        if (!tray) {
            return null;
        }

        if (tray.trayType === TrayType.Service) {
            return `${tray.name} (Service)`;
        }
        return tray.name;
    }

    computeVisibilityIcon(disabled: boolean) {
        return disabled ? 'fa-eye' : 'fa-eye-slash';
    }

    canVisibilityBeChanged() {
        return this.tray.disabled || (!this.tray.disabled && !this.tray.slots.some(item => item.hasTools))
    }
}
